import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'form',
    'fileInput',
    'uploadStatus',
    'uploadThumbnail',
    'uploadFilename',
    'progressCircle',
  ];

  connect() {}

  triggerFileInput(event) {
    this.fileInputTarget.click();
  }

  handleFileChange(event) {
    if (this.fileInputTarget.files && this.fileInputTarget.files[0]) {
      const file = this.fileInputTarget.files[0];
      // Show the upload status
      if (this.hasUploadStatusTarget) {
        this.uploadStatusTarget.classList.remove('hidden');
      }

      // Update the filename
      if (this.hasUploadFilenameTarget) {
        this.uploadFilenameTarget.textContent = file.name;
      }

      // Create a thumbnail preview if it's an image
      if (file.type.includes('image') && this.hasUploadThumbnailTarget) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadThumbnailTarget.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      // Animate the progress circle
      if (this.hasProgressCircleTarget) {
        // Start with full circle (56.55 is the circumference)
        this.progressCircleTarget.setAttribute('stroke-dashoffset', '56.55');

        // Animate to 25% complete
        setTimeout(() => {
          this.progressCircleTarget.setAttribute('stroke-dashoffset', '42.41');
        }, 500);

        // Animate to 75% complete
        setTimeout(() => {
          this.progressCircleTarget.setAttribute('stroke-dashoffset', '14.14');
        }, 1000);
      }

      // Submit the form after a short delay to show the animation
      this.formTarget.requestSubmit();
    }
  }

  addHiddenField(name, value) {
    let input = this.formTarget.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      this.formTarget.appendChild(input);
    }
    input.value = value;
  }
}
